import axios from "axios";
import API from "../_helpers/endpointService";
import { applyDataTable } from '../components/custom/dataTable';

export const getuserdata = (data) => {
    let apiUrl = API.USER_MANAGEMENT;
    return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
        method: "POST",
        url: apiUrl,
        data: data,
    })
        .then((response) => {
            dispatch({ type: "SHOW_LOADER", data: false })
            if (response?.status === 200) {
                dispatch({ type: "USER_TABLE", data: response.data });
            } else {
            }
        })
        .catch((error) => {
            dispatch({ type: "SHOW_LOADER", data: false })
            if (error?.response?.status === 401) {
                // logOut();
            }
        });
    }
};